import React from 'react'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import Affiliate from 'modules/dashboard/affiliate/Affiliate'

export default function DashAffiliate() {
  return (
    <DashContainer title={'Programa de Indicação'}>
      <Affiliate />
    </DashContainer>
  )
}
